import { JSX } from "react";

import { Outlet } from "react-router-dom";

function CenterDashboardPage(): JSX.Element {
  return <Outlet />;
}

export default CenterDashboardPage;
